import {style} from 'typestyle'
import * as csstips from 'csstips'

export const Nav = style({
    ...csstips.flexRoot,
    width: '100%',
    maxWidth: 480,
    height: 50,
    overflow: 'hidden',
    margin: 'auto',
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#fff',
    zIndex: 10,
    $nest: {
        '&:before': {
            'content': `""`,
            'position': 'absolute',
            'top': '0',
            'left': '0',
            'right': '0',
            'borderTop': '1px solid #f0f0f0',
            '-webkit-transform-origin': '100% 0',
            'transformOrigin': '100% 0',
            '-webkit-transform': 'scaleY(.5)',
            'transform': 'scaleY(.5)'
        }
    }
})

export const SpecialIconStyle = style({
    overflow: 'unset',
    $nest: {
        '& img': {
            bottom: 4
        }
    }
})

export const NavItem = style({
    ...csstips.flex1,
    ...csstips.centerJustified,
    width: '33.33333%',
    position: 'relative'
})

export const NavItemIcon = style({
    'position': 'absolute',
    'bottom': 3,
    'left': '50%',
    '-webkit-transform': 'translate(-50%)',
    'transform': 'translate(-50%)',
    'width': '44px',
    'height': 44,
    'backgroundSize': '100% 100%'
})

export const showRedPot = style({
    $nest: {
        '&::after': {
            content: `""`,
            position: 'absolute',
            right: 5,
            top: 0,
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: '#ff5a31'
        }
    }
})



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.style.ts